import React, { useState, useEffect } from "react";
import NavbarDashboard from "../../../components/Navbar/NavbarDashboard";
import { Link } from "react-router-dom";
import fundamentals_icon from "../../../assets/images/icon_fundamentals.png";
import "../../../styles/style_label.css";
import LinearProgress from "@mui/joy/LinearProgress";
import Typography from "@mui/joy/Typography";
import { firebase, doc, db, getDoc, auth } from "../../../firebase";
import "firebase/compat/firestore";
import { IoChevronBackOutline } from "react-icons/io5";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../../../styles/tabs.css";

function Progress() {
  let nbsp = "\u00a0";

  // Step 2: Initialize a state variable
  const [quizFinishedValueRoadRage, setQuizFinishedValue] = useState(0);
  const [quizFinishedValueDefensive, setQuizFinishedValue2] = useState(0);
  const [quizFinishedValueTips, setQuizFinishedValue3] = useState(0);
  const completedStyle = { color: "green" };
  const notStartedStyle = { color: "red" };

  const getQuizFinishedStatusRoadRage = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "roadrage", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };

  const getQuizFinishedStatusDefensive = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "defensive", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue2(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };

  const getQuizFinishedStatusTips = async () => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId, "tips", userId);

      try {
        const docSnapshot = await getDoc(userDocRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          if (data.quizFinished !== undefined) {
            const quizFinished = data.quizFinished;
            const quizFinishedInt = quizFinished ? 100 : 0;

            // Step 4: Set the state variable with quizFinishedInt value
            setQuizFinishedValue3(quizFinishedInt);

            // Update other elements
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `${quizFinishedInt}`;
          } else {
            console.log("Field 'quizFinished' is missing in the document.");
            const defaultQuizFinishedInt = 0;
            const quizFinishedTagElement =
              document.getElementById("quizFinishedTag");
            quizFinishedTagElement.textContent = `{${defaultQuizFinishedInt}}`;
          }
        } else {
          console.log("Document does not exist for user with ID:", userId);
        }
      } catch (error) {
        console.error("Error fetching quiz finished status:", error);
      }
    }
  };

  useEffect(() => {
    getQuizFinishedStatusRoadRage();
  }, []); //

  useEffect(() => {
    getQuizFinishedStatusDefensive();
  }, []);

  useEffect(() => {
    getQuizFinishedStatusTips();
  }, []);

  const quizStatusTextRoadRage =
    quizFinishedValueRoadRage === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const quizStatusTextDefensive =
    quizFinishedValueDefensive === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const quizStatusTextTips =
    quizFinishedValueTips === 100 ? (
      <span style={completedStyle}>Completed</span>
    ) : (
      <span style={notStartedStyle}>Not Started</span>
    );

  const [activeTab, setActiveTab] = useState(1); // Default to the first tab

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="container-dashboard">
      <NavbarDashboard />

      <div className="container-main-contents">
        <div className="container-main-header">
          <div className="container-main-header-title">
            <Link class="back-button" to={"/"}>
              <IoChevronBackOutline />
            </Link>
            <h1>ROAD SAFETY</h1>
          </div>

          <p>
            Road safety is critically important due to its direct impact on human lives. Adhering to road safety guidelines, such as wearing seat belts, obeying speed limits, and avoiding distracted driving, significantly reduces the risk of accidents and their associated human costs. The implementation of these measures leads to a substantial reduction in fatalities and injuries resulting from road accidents. Beyond the immediate personal toll, road safety has broader implications for society. It minimizes economic burdens by preventing medical expenses, property damage, and lost productivity. Additionally, road safety contributes to public health by reducing hospitalizations and medical treatments associated with accidents. 
          </p>
        </div>
        <div className="lesson-content">
          <Tabs>
            <TabList className="tab-selector">
              <Tab
                onClick={() => handleTabClick(1)}
                className={activeTab === 1 ? "active-tab tab-ind" : "tab-ind"}
              >
                <h1>Basics</h1>
              </Tab>

              <Tab
                onClick={() => handleTabClick(2)}
                className={activeTab === 2 ? "active-tab tab-ind" : "tab-ind"}
              >
                <h1>Road Safety Tips</h1>
              </Tab>
            </TabList>

            {activeTab === 1 && (
              <div className="lesson-selection">
                <div className="lesson-selection-card">
                  <h4>Road Rage</h4>
                  <Link to="/rs_roadrage">
                    <p className="start-learning">Start Learning</p>
                  </Link>
                  <p>{quizStatusTextRoadRage}</p>
                </div>
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Defensive Driving Overview</h4>
                  <Link to="/rs_defensive">
                    <p className="start-learning">Start Learning</p>
                  </Link>
                  <p>{quizStatusTextDefensive}</p>
                </div>
              </div>
            )}

            {activeTab === 2 && (
              <div className="lesson-selection">
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Tips to Avoid Road Rage</h4>
                  <Link to="/rs_tips">
                    <p className="start-learning">Start Learning</p>
                  </Link>
                  <p>{quizStatusTextTips}</p>
                </div>
              </div>
            )}

            {activeTab === 3 && (
              <div className="lesson-selection">
                {/* /////////// */}
                <div className="lesson-selection-card">
                  <h4>Test</h4>
                  <p className="start-learning">Start Learning</p>
                </div>
              </div>
            )}

            {/* <TabPanel>
              <h2>Basics Page</h2>
            </TabPanel>
            <TabPanel>
              <h2>Additinals Page</h2>
            </TabPanel>
            <TabPanel>
              <h2>Quizzes Page</h2>
            </TabPanel> */}
          </Tabs>
        </div>
      </div>
    </div>
  );
}
export default Progress;
